import html from './iframe.html';
import configPromise from './config';

const writeFrame = (id, html, { css = '', className = '', parent = document.body }) => {
  const iframe = document.createElement('iframe');
  iframe.name = id;
  iframe.id = id;
  iframe.style.cssText = css;
  iframe.className = className;

  parent.appendChild(iframe);

  iframe.contentWindow.document.open('text/html', 'replace');
  iframe.contentWindow.document.write(html);
  iframe.contentWindow.document.close();

  return iframe;
};

const iframesPromise = configPromise.then(config => {
  // Add configuration to the iframe templates.
  const renderedHtml = html
    .replace(/{{webChatBaseUrl}}/g, config.webChatBaseUrl)
    .replace(/{{webChatConfig}}/g, JSON.stringify(config));

  const chatWindowFrameHtml = renderedHtml.replace(/{{initialiseComponent}}/g, 'chatPanel');

  const launcherFrameHtml = renderedHtml.replace(/{{initialiseComponent}}/g, 'launcher');

  // Create wrapper for the launcher and launcher tooltip
  let launcherWrapperDiv;
  let launcherFrame;

  if (config.showLauncher) {
    // Create launcher iframe
    launcherWrapperDiv = document.createElement('div');
    launcherWrapperDiv.id = 'ambitLauncherWrapper';
    launcherWrapperDiv.className = '';
    launcherWrapperDiv.style.cssText = 'display: none;';
    document.body.appendChild(launcherWrapperDiv);

    launcherFrame = writeFrame('ambitLauncher', launcherFrameHtml, {
      parent: launcherWrapperDiv
    });

    // After 500ms, remove the "display: none" from the launcher. This prevents an unstyled iframe
    // from appearing briefly on firefox.
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      setTimeout(() => (launcherWrapperDiv.style.cssText = ''), 500);
    } else {
      launcherWrapperDiv.style.cssText = '';
    }

    // Add tooltip to the document
    if (config.strings.tooltip) {
      const tooltipDiv = document.createElement('div');
      tooltipDiv.id = 'ambitTooltipContainer';
      tooltipDiv.innerHTML = `<div id="ambitTooltip"><div id="ambitTooltipTriangle"></div>${
        config.strings.tooltip
      }</div>`;
      launcherWrapperDiv.appendChild(tooltipDiv);
    }
  }

  // Append chat window frame
  let chatWindowFrame;
  if (config.inline) {
    chatWindowFrame = writeFrame('ambitInlineChatWindow', chatWindowFrameHtml, {
      parent: config.inline
    });
  } else {
    chatWindowFrame = writeFrame('ambitChatWindow', chatWindowFrameHtml, {
      css: 'display: none;',
      className: 'ambitClosed'
    });
  }

  if (config.showLauncher) {
    const handleMouseEnter = () => {
      const tooltipNode = document.getElementById('ambitLauncherWrapper');
      if (
        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) &&
        chatWindowFrame.className === 'ambitClosed'
      ) {
        tooltipNode.className = 'ambitShowTooltip';
      }
    };

    const handleMouseLeave = () => {
      const tooltipNode = document.getElementById('ambitLauncherWrapper');
      tooltipNode.className = '';
    };

    launcherWrapperDiv.addEventListener('mouseover', handleMouseEnter);
    launcherWrapperDiv.addEventListener('mouseleave', handleMouseLeave);
  }

  return { launcherFrame, chatWindowFrame, launcherWrapperDiv };
});

export default iframesPromise;



// WEBPACK FOOTER //
// ./src/initialiser/iframes.js